<template>
  <div class="maps">
    <v-head></v-head>
    <div id="allmap" style="width: 800px;height: 800px"></div>

  </div>

</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return {


      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    ready () {
      var _this = this;
      // 百度地图API功能
      var map = new BMap.Map("allmap");
      //    var point = new BMap.Point(116.331398,39.897445);
     /* var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(r){
        console.log(55566,r);
        if(this.getStatus() == BMAP_STATUS_SUCCESS){
          var mk = new BMap.Marker(r.point);
          map.addOverlay(mk);
          map.panTo(r.point);
          map.centerAndZoom(r.point, 15);
          map.addControl(new BMap.NavigationControl());
          map.addControl(new BMap.NavigationControl());
          map.addControl(new BMap.ScaleControl());
          map.addControl(new BMap.OverviewMapControl());
          map.addControl(new BMap.MapTypeControl());
        }
        else {
          alert('failed'+this.getStatus());
        }
      },{enableHighAccuracy: true})*/

      var local = new BMap.LocalSearch(map, {
        renderOptions:{map: map}
      });
      local.search(_this.$route.params.name);
//      local.search(["深圳红松会所N","深圳天安会所N","深圳深国投广场N"]);
    }
  }
</script>

<style>
  .maps{width:100%;margin: 0 auto;}
  #allmap{width:100% !important;margin-top: 5%}
  /*.BMap_mask{width: 100%}*/

</style>



// WEBPACK FOOTER //
// maps.vue?25bcb1e1